import { Button, Stack, Loader, useCoralBreakpoints } from '@krakentech/coral';
import { IconArrowRightFromBracket } from '@krakentech/icons';
import { useIsClient } from '@krakentech/utils';

import { useLogout } from '@/hooks/utils/useLogout';

const LogoutButton = () => {
  const { isMaxMd } = useCoralBreakpoints();
  const isClient = useIsClient();
  const { logout, isPending } = useLogout();

  const isMaxMdBreakpoint = isClient && isMaxMd;

  return (
    <Button
      color="tertiary"
      size={isMaxMdBreakpoint ? 'medium' : 'small'}
      title="Logout"
      onClick={logout}
      disabled={isPending}
    >
      {isMaxMdBreakpoint ? (
        <>
          {isPending ? (
            <Loader size={16} color="text" />
          ) : (
            <IconArrowRightFromBracket size={18} />
          )}
        </>
      ) : (
        <Stack gap="sm" alignItems="center">
          {isPending ? (
            <Loader size={16} color="text" />
          ) : (
            <IconArrowRightFromBracket size={18} />
          )}
          <span>Logout</span>
        </Stack>
      )}
    </Button>
  );
};

export default LogoutButton;
